// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-profile-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.admin-profile-container {
  display: flex;
  min-height: 100vh;
}

/* 사이드바 스타일 */
.admin-sidebar {
  width: 250px;
  background-color: #ffffff;
  border-right: 1px solid #e0e0e0;
  min-height: 100vh;
}

.sidebar-menu {
  padding: 20px;
}

.sidebar-menu h3 {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.sidebar-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu ul li {
  padding: 12px 0;
  color: #666;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.sidebar-menu ul li:hover {
  color: #e84118;
}

.sidebar-menu ul li.active {
  color: #e84118;
  font-weight: 600;
  background-color: #fff5f3;
  padding-left: 10px;
  margin-left: -10px;
  border-left: 3px solid #e84118;
}

/* 메인 컨텐츠 영역 */
.admin-content {
  flex: 1 1;
  padding: 30px;
  background-color: #ffffff;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e84118;
}

.content-header h2 {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.content-actions {
  display: flex;
  gap: 10px;
}

.btn-add-admin {
  background-color: #e84118;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.btn-add-admin:hover {
  background-color: #d63011;
}

/* 테이블 섹션 */
.admin-table-section {
  background-color: #ffffff;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.table-info {
  color: #333;
  font-size: 16px;
  font-weight: 500;
}

/* 테이블 컨테이너 */
.admin-table-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
}

.admin-table thead {
  background-color: #f8f9fa;
}

.admin-table thead th {
  padding: 15px 10px;
  text-align: center;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
}

.admin-table tbody td {
  padding: 15px 10px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  color: #555;
  font-size: 14px;
}

.admin-table tbody tr:hover {
  background-color: #f8f9fa;
}

.admin-table tbody tr:last-child td {
  border-bottom: none;
}

/* 체크박스 스타일 */
.admin-table input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* 편집 입력 필드 */
.edit-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 13px;
  text-align: center;
}

.edit-input:focus {
  outline: none;
  border-color: #e84118;
}

/* 편집 액션 버튼들 */
.edit-actions {
  display: flex;
  gap: 5px;
  justify-content: center;
}

.btn-save, .btn-cancel, .btn-edit {
  padding: 6px 12px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

.btn-save {
  background-color: #28a745;
  color: white;
}

.btn-save:hover {
  background-color: #218838;
}

.btn-cancel {
  background-color: #6c757d;
  color: white;
}

.btn-cancel:hover {
  background-color: #545b62;
}

.btn-edit {
  background-color: #e84118;
  color: white;
}

.btn-edit:hover {
  background-color: #d63011;
}

/* 테이블 액션 버튼들 */
.table-actions {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.btn-delete {
  background-color: #333;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.btn-delete:hover {
  background-color: #222;
}

/* 테이블 푸터 */
.table-footer {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.btn-save-all {
  background-color: #e84118;
  color: white;
  border: none;
  padding: 15px 50px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
}

.btn-save-all:hover {
  background-color: #d63011;
}

/* 로딩 및 에러 상태 */
.loading, .error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  font-size: 16px;
  color: #666;
}

.error {
  color: #e84118;
}

/* 모달 스타일 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: 500;
  font-size: 14px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #e84118;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
}

.btn-create {
  background-color: #e84118;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.btn-create:hover {
  background-color: #d63011;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
  .admin-profile-container {
    flex-direction: column;
  }
  
  .admin-sidebar {
    width: 100%;
    min-height: auto;
  }
  
  .admin-content {
    padding: 20px;
  }
  
  .admin-table-container {
    overflow-x: auto;
  }
  
  .admin-table {
    min-width: 800px;
  }
}

@media (max-width: 768px) {
  .content-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .edit-actions {
    flex-direction: column;
    gap: 3px;
  }
  
  .btn-save, .btn-cancel, .btn-edit {
    font-size: 11px;
    padding: 4px 8px;
  }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/AdminProfilePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".admin-profile-page {\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.admin-profile-container {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* 사이드바 스타일 */\n.admin-sidebar {\n  width: 250px;\n  background-color: #ffffff;\n  border-right: 1px solid #e0e0e0;\n  min-height: 100vh;\n}\n\n.sidebar-menu {\n  padding: 20px;\n}\n\n.sidebar-menu h3 {\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.sidebar-menu ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-menu ul li {\n  padding: 12px 0;\n  color: #666;\n  cursor: pointer;\n  font-size: 14px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.sidebar-menu ul li:hover {\n  color: #e84118;\n}\n\n.sidebar-menu ul li.active {\n  color: #e84118;\n  font-weight: 600;\n  background-color: #fff5f3;\n  padding-left: 10px;\n  margin-left: -10px;\n  border-left: 3px solid #e84118;\n}\n\n/* 메인 컨텐츠 영역 */\n.admin-content {\n  flex: 1;\n  padding: 30px;\n  background-color: #ffffff;\n}\n\n.content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e84118;\n}\n\n.content-header h2 {\n  color: #333;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.content-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-add-admin {\n  background-color: #e84118;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.btn-add-admin:hover {\n  background-color: #d63011;\n}\n\n/* 테이블 섹션 */\n.admin-table-section {\n  background-color: #ffffff;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.table-info {\n  color: #333;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n/* 테이블 컨테이너 */\n.admin-table-container {\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #ffffff;\n}\n\n.admin-table thead {\n  background-color: #f8f9fa;\n}\n\n.admin-table thead th {\n  padding: 15px 10px;\n  text-align: center;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 14px;\n}\n\n.admin-table tbody td {\n  padding: 15px 10px;\n  text-align: center;\n  border-bottom: 1px solid #f0f0f0;\n  color: #555;\n  font-size: 14px;\n}\n\n.admin-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.admin-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* 체크박스 스타일 */\n.admin-table input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n/* 편집 입력 필드 */\n.edit-input {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 13px;\n  text-align: center;\n}\n\n.edit-input:focus {\n  outline: none;\n  border-color: #e84118;\n}\n\n/* 편집 액션 버튼들 */\n.edit-actions {\n  display: flex;\n  gap: 5px;\n  justify-content: center;\n}\n\n.btn-save, .btn-cancel, .btn-edit {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.btn-save {\n  background-color: #28a745;\n  color: white;\n}\n\n.btn-save:hover {\n  background-color: #218838;\n}\n\n.btn-cancel {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-cancel:hover {\n  background-color: #545b62;\n}\n\n.btn-edit {\n  background-color: #e84118;\n  color: white;\n}\n\n.btn-edit:hover {\n  background-color: #d63011;\n}\n\n/* 테이블 액션 버튼들 */\n.table-actions {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n}\n\n.btn-delete {\n  background-color: #333;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.btn-delete:hover {\n  background-color: #222;\n}\n\n/* 테이블 푸터 */\n.table-footer {\n  display: flex;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.btn-save-all {\n  background-color: #e84118;\n  color: white;\n  border: none;\n  padding: 15px 50px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.btn-save-all:hover {\n  background-color: #d63011;\n}\n\n/* 로딩 및 에러 상태 */\n.loading, .error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n  font-size: 16px;\n  color: #666;\n}\n\n.error {\n  color: #e84118;\n}\n\n/* 모달 스타일 */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close:hover {\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  color: #333;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #e84118;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.btn-create {\n  background-color: #e84118;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.btn-create:hover {\n  background-color: #d63011;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 1024px) {\n  .admin-profile-container {\n    flex-direction: column;\n  }\n  \n  .admin-sidebar {\n    width: 100%;\n    min-height: auto;\n  }\n  \n  .admin-content {\n    padding: 20px;\n  }\n  \n  .admin-table-container {\n    overflow-x: auto;\n  }\n  \n  .admin-table {\n    min-width: 800px;\n  }\n}\n\n@media (max-width: 768px) {\n  .content-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: flex-start;\n  }\n  \n  .edit-actions {\n    flex-direction: column;\n    gap: 3px;\n  }\n  \n  .btn-save, .btn-cancel, .btn-edit {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
